import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "./NewsEventsReadMore.css";
import Gfooter from "../Component/Gfooter";

function NewsEventsReadMore() {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [multiImages, setMultiImages] = useState([]);

useEffect(() => {
  const fetchNewsDetail = async () => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_event_by_id",
        new URLSearchParams({
          news_id: id
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      );

      console.log("API RESPONSE:", response.data);

      if (response.data.status === "true") {
        const newsData = response.data.data;
        setNews(newsData);
        setMultiImages(newsData.multi_news_image || []);
      }

    } catch (error) {
      console.error("Error fetching news detail:", error);
    }
  };

  if (id) {
    fetchNewsDetail();
  }

}, [id]);

  if (!news) return <div className="text-center py-5">Loading...</div>;

  const fullImageURLs = multiImages.map(
    (img) => `https://cyberathon.com/NLF/${img}`
  );

  return (
    <>
      <section className="news-read-section">
        <div className="container">

          {/* TITLE */}
          <h1 className="news-read-title mt-5 text-center">
            {news.news_heading}
          </h1>

          {/* DESCRIPTION */}
          <div className="news-read-description text-justify text-center">
            {news.news_address}
          </div>

          {/* SHOW ONLY FIRST 5 IMAGES */}
          {fullImageURLs.length > 0 && (
            <div className="news-multi-image-box">
              {fullImageURLs.slice(0, 5).map((img, index) => (
                <div
                  key={index}
                  className="news-multi-img-item"
                  onClick={() => setSelectedImageIndex(index)}
                >
                  <img src={img} alt="news" />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* MODAL */}
      {selectedImageIndex !== null && (
        <div
          className="news-image-modal"
          onClick={() => setSelectedImageIndex(null)}
        >
          <div
            className="modal-content-wrapper"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-arrow left"
              onClick={() =>
                setSelectedImageIndex(
                  selectedImageIndex === 0
                    ? fullImageURLs.length - 1
                    : selectedImageIndex - 1
                )
              }
            >
              ❮
            </button>

            <img
              src={fullImageURLs[selectedImageIndex]}
              alt="expanded"
            />

            <button
              className="modal-arrow right"
              onClick={() =>
                setSelectedImageIndex(
                  selectedImageIndex === fullImageURLs.length - 1
                    ? 0
                    : selectedImageIndex + 1
                )
              }
            >
              ❯
            </button>
          </div>
        </div>
      )}

      <Gfooter />
    </>
  );
}

export default NewsEventsReadMore;